// src/components/Common/LogoutButton.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const LogoutButton = ({ style }) => {
    const navigate = useNavigate();

    const handleLogout = async (e) => {
        e.preventDefault();
        console.log('Użytkownik wylogowany!');
        localStorage.removeItem('authToken');
        alert('Zostałeś wylogowany.');
        navigate('/login-registration?logout');
    };

    return (
        <button
            onClick={handleLogout}
            className="logout-button"
            style={style}
        >
            Wyloguj
        </button>
    );
};

export default LogoutButton;